import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Claims } from '@core/authentication/claims';
import { aggregator } from '@env/aggregator/aggregator';

const appLocale = Claims.Country.toLocale(aggregator.settings.claims.defaults.country);

export function mpmSettlementDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const inputDate = new Date(control.value);
    const pastDate = new Date();
    pastDate.setDate(new Date().getDate() - 90);

    return inputDate >= pastDate
      ? null
      : { dateOutOfRangeMpm: 'Must be a date in the future or last 90 days' };
  };
}

export function lnsAndNmbSettlementDateValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const inputDate = new Date(control.value);
    const today = new Date();
    const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

    if (inputDate < firstDayOfLastMonth) {
      return { dateOutOfRangeLnsAndNmb: 'Date out of range' };
    }

    return null;
  };
}

export function getSettlementDateOutOfRangeMessageForMpm() {
  const before90Days = new Date();
  before90Days.setDate(new Date().getDate() - 90);
  return `Settlement date must be after ${before90Days.toLocaleDateString(appLocale)}.`;
}

export function getSettlementDateOutOfRangeMessageForLnsAndNmb(name: string) {
  const today = new Date();
  const firstDayOfLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);

  return `${name} must be after ${firstDayOfLastMonth.toLocaleDateString(appLocale)}.`;
}

export function requiredWhenControlHasValue(otherControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (otherControl.value && !control.value) {
      return { required: true };
    }
    return null;
  };
}

// TODO: legacy code/will be removed [future release]

/**
 * @deprecated
 */
export function hasErrors(control: AbstractControl): boolean {
  return control.touched && control.invalid && control.errors != null;
}
